"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const modal_js_1 = __importDefault(require("bootstrap/js/dist/modal.js"));
exports.default = {
    mounted() {
        let parent = this;
        let parentElement = this.el;
        let container = this.el.querySelector("#user_wants_in_text");
        let organizer = this.el.querySelector("#user_wants_in_organizer");
        container.setAttribute("data-text", container.innerText);
        var modal = new modal_js_1.default(parentElement, {});
        this.handleEvent("user_wants_in", (payload) => {
            let text = container.getAttribute("data-text");
            container.innerText = text.replace("%USER", payload.name);
            organizer.style.display = payload.organizer ? "block" : "none";
            this.el.querySelector("#chat_user_id").value = payload.user_id.toString();
            this.el.querySelector("#chat_room_id").value = payload.room_id.toString();
            modal.show();
        });
    }
};
